import $http from "@/http/index";

//获取系统配置列表
export const systemConfigList = (data) => {
    return $http.get("/api/systemConfig/list", {
        params: data
    })
}


//获取来源
export const getSource = (data) => {
    return $http.post("/api/userSource/submit", data)
}
